import { Injectable } from '@angular/core';
import { ColumnState } from 'ag-grid-enterprise';
import { Observable } from 'rxjs';

import { AbstractMixedStorageDataStore } from 'v2/data-store/abstract.mixed-storage-data-store';
import {
  MixedStorageStore,
  MixedStorageStoreHash,
} from 'v2/data-store/data-store.types';
import { State } from 'v2/data-store/state';
import { LocalStorageKeys } from 'v2/modules/shared/interfaces/localstorage.interface';

export interface ICostLayersViewSettingsState {
  costLayerLogColumnsForAll :ColumnState[];
  costLayerLogColumnsForQuantity :ColumnState[];
  costLayersColumns :ColumnState[];
  costLayersFilters :{ [key :string] :any };
  productCostLayersColumns :ColumnState[];
  productCostLayersFilters :{ [key :string] :any };
}

@Injectable({ providedIn: 'root' })
export class CostLayersViewSettingsService extends AbstractMixedStorageDataStore<
  ICostLayersViewSettingsState,
  State<ICostLayersViewSettingsState>
> {
  readonly state = new State<ICostLayersViewSettingsState>({
    costLayerLogColumnsForAll: null,
    costLayerLogColumnsForQuantity: null,
    costLayersColumns: null,
    costLayersFilters: null,
    productCostLayersColumns: null,
    productCostLayersFilters: null,
  });
  readonly state$ :Observable<ICostLayersViewSettingsState> = this.state.$;
  readonly storageKey = LocalStorageKeys.COST_LAYERS_VIEW_SETTINGS;
  readonly storeHash :MixedStorageStoreHash<ICostLayersViewSettingsState> = {
    '*': MixedStorageStore.LOCAL,
    // filters are more ephemeral; they only persist through a session
    costLayersFilters: MixedStorageStore.SESSION,
    productCostLayersFilters: MixedStorageStore.SESSION,
  };

  constructor() {
    super();
    this.init();
  }
}
